// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBY1RAVg8pUXxF5Elkzxe1mSa_qaebdvNM",
  authDomain: "fundacion-arduvi.firebaseapp.com",
  projectId: "fundacion-arduvi",
  storageBucket: "fundacion-arduvi.appspot.com",
  messagingSenderId: "1099209855014",
  appId: "1:1099209855014:web:d4ee39c87039c332ed96e7",
  measurementId: "G-PGZT2X7PQ6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const messaging = getMessaging(app);
